import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, Checkbox } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function RetrievalCheckPage() {
  const [criterion1, setCriterion1] = useState('');
  const [cutItem, setCutItem] = useState('');
  const [firstAction, setFirstAction] = useState('');
  const [reviewBooked, setReviewBooked] = useState(false);
  const [reviewDate, setReviewDate] = useState('');

  return (
    <TaskPage
      phase="decide"
      title="Retrieval Check & Habit Hook"
      pageNumber={8}
      instruction="Quick recall to strengthen memory and follow-through. Add a recurring weekly 10-minute 'Decide' block to revisit criteria and triage new requests."
      whyItMatters="Retrieval + spaced review improve retention and follow-through."
      coachRail={{
        timing: "3 minutes",
        tips: "Add a recurring weekly 10-minute 'Decide' block to your calendar.",
        debrief: "Review date booked? Is it on your calendar?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Quick Recall</h3>
          <div className="space-y-4">
            <TextInput
              label="My #1 criterion is"
              value={criterion1}
              onChange={(e) => setCriterion1(e.target.value)}
              placeholder="What's your top criterion?"
            />
            <TextInput
              label="I can name one thing we cut and why"
              value={cutItem}
              onChange={(e) => setCutItem(e.target.value)}
              placeholder="What did you cut and why?"
            />
            <div>
              <TextInput
                label="My first next action is"
                value={firstAction}
                onChange={(e) => setFirstAction(e.target.value)}
                placeholder="What's your first action?"
                className="mb-2"
              />
              <label className="flex items-center gap-3 cursor-pointer">
                <Checkbox
                  checked={false}
                  onChange={() => {}}
                  label="and it's calendar-blocked"
                />
              </label>
            </div>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-3 cursor-pointer">
                <Checkbox
                  checked={reviewBooked}
                  onChange={(e) => setReviewBooked(e.target.checked)}
                  label="Review date booked?"
                />
              </label>
              {reviewBooked && (
                <TextInput
                  type="date"
                  value={reviewDate}
                  onChange={(e) => setReviewDate(e.target.value)}
                  placeholder="Date"
                />
              )}
            </div>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Habit Hook</h3>
          <p className="text-sm text-[var(--text-sec)]">
            Add a recurring weekly 10-minute "Decide" block to revisit criteria and triage new requests.
          </p>
          <label className="flex items-center gap-3 cursor-pointer mt-3">
            <Checkbox
              checked={false}
              onChange={() => {}}
              label="Weekly Decide block added to calendar"
            />
          </label>
        </div>

        <Callout type="tip" phase="decide">
          <p className="text-sm">Retrieval + spaced review improve retention and follow-through. Set up your weekly Decide block now.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






